<template>
    <v-container fluid class="login-container">
        <view-card-template>
            <template #cardTitle>
                <v-row>
                    <v-col sm="1">
                        <v-avatar size="small"
                        v-on:click="onCloseModal()"
                         rounded="0"><img src="../../assets/close.png"
                         style="width:55%"
                         class="v-slider__thumb"
                         elevation="2"
                         alt="decorative image"
                         ></v-avatar>
                    </v-col>
                    <v-col sm="1">
                        <v-avatar size="small"
                        v-on:click="firstPage(page)"
                         rounded="0"><img src="../../assets/first-page.png"
                         style="width:55%"
                         class="v-slider__thumb"
                         elevation="2"
                         alt="decorative image"
                         ></v-avatar>
                    </v-col>
                    <v-col sm="1">
                        <v-avatar size="small"
                         v-on:click="prevPage(page)"
                         rounded="0"><img src="../../assets/prev-page.png"
                         style="width:55%"
                         class="v-slider__thumb"
                         elevation="2"
                         alt="decorative image"
                         ></v-avatar>
                    </v-col>
                    <v-col sm="6">
                        <p>{{ strManifestName }}</p>
                        <p>Current Page:</p>
                        <p>{{ page }} of {{ numPages }}</p>
                    </v-col>
                    <v-col sm="1">
                        <v-avatar size="small"
                        v-on:click="changePage(page)"
                         rounded="0"><img src="../../assets/next-page.png"
                         style="width:55%"
                         class="v-slider__thumb"
                         elevation="2"
                         alt="decorative image"
                         ></v-avatar>
                    </v-col>
                    <v-col sm="1">
                        <v-avatar size="small"
                         v-on:click="endPage(page)"
                         rounded="0"><img src="../../assets/lastPage-transformed.png"
                         style="width:55%"
                         class="v-slider__thumb"
                         elevation="2"
                         alt="decorative image"
                         ></v-avatar>
                    </v-col>
                    <v-col sm="1">
                        <v-avatar size="small"
                         v-on:click="downloadPDF(presignedUrl,strManifestName)"
                         rounded="0"><img src="../../assets/download.png"
                         style="width:55%"
                         class="v-slider__thumb"
                         elevation="2"
                         alt="decorative image"
                         ></v-avatar>
                    </v-col>
                </v-row>
            </template>
            <template #cardBody>
                <v-row></v-row>
                <div
                    style="height:100%"
                    class="d-flex flex-column"
                >   
                    <div v-if="isLoading" style="width: 50%; height: 50%">
                        <img  src="../../assets/loading.gif" alt="Loading..." />
                    </div>
                    
                        <pdf
                        v-bind:src="presignedUrl"
                        :page=page
                        style="width: 100%"
                        @num-pages="numPages = $event"
                    ></pdf>
                </div>
            </template>

        </view-card-template>
    </v-container>
</template>
<script>
import pdf from 'vue-pdf';
import axios from 'axios';
import ViewCardTemplate from './ViewCardTemplate.vue';

export default {
  components: {
    pdf,
    ViewCardTemplate,
  },
  props: ['strManifestName', 'strCompanyName'],

  watch: {
    strManifestName(newVal) { // watch it
      this.presignedUrl = ''
      this.getBase64(newVal);
      this.page = 1;
    },
  },
  data() {
    return {
      show: true,
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      source: '',
      presignedUrl: '',
      isLoading: false,
    };
  },
  methods: {
    changePage(curPage) {
      if (curPage === this.numPages) this.page = curPage;
      else this.page = curPage + 1;
    },
    prevPage(curPage) {
      if (curPage === 1) this.page = curPage;
      else this.page = curPage - 1;
    },
    firstPage() {
      this.page = 1;
    },
    endPage() {
      this.page = this.numPages;
    },
    error(err) {
      throw err;
    },
    async getBase64() {
      const data = JSON.stringify(
        {
          company: this.strCompanyName,
          fileName: this.strManifestName,
        },
      );
      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_GETPDF_URL,
        headers: {
          'x-api-key': process.env.VUE_APP_API_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      try {
        const response = await axios(config);
        this.presignedUrl = response.data;
      } catch(e) {
        console.log(e)
      }
    },
    onCloseModal() {
      this.$emit('clicked', 'someValue');
      this.page = 1;
    },
    onOpenModal() {
      this.$emit('opened', 'someValue');
      this.page = 1;
      this.numPages = 0;
      this.getBase64();
    },
    async downloadPDF(base64, pdf1) {
      const linkSource = `${base64}`;
      const downloadLink = document.createElement('a');
      const fileName = pdf1;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
  },
  mounted() {
    this.getBase64();
  },
};
</script>
<style>
.v-slider__thumb{
  cursor:pointer;
  height:42px;
  width:42px;
}
.login-container {
   background-image: url("~@/assets/background.png"); /* Replace with the path to your PNG image */
   background-size: cover;
   background-position: center;
   min-height: 100vh;
 }
</style>
